import * as React from "react";
import {Button, Stack, Typography,Box} from '@mui/material';
import EventDetailCard from "./EventDetailCard";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import {useScreen} from "./hooks/useScreen";

const EventDetailList = ({events, title}) => {
    const {changeScreen} = useScreen();
    return (
        <Stack
            direction="column"
            justifyContent="left"
            alignItems="flex-start"
            spacing={2}
        >
            <Button className="liked"
                    onClick={() => changeScreen(1)}
                    sx={{marginBottom:1}}
                    startIcon={<ArrowBackIcon></ArrowBackIcon>}
                    aria-label={"Retour vers liste évènements"}
            >
                Retour vers liste évènements
            </Button>
            <Typography variant={'h3'} sx={{color: '#26383E'}}>
                {title}
            </Typography>
            {events && events.map((theEvent,index) => (
                <Box key={index} sx={{width:'100%'}}>
                    <EventDetailCard
                        eventToSee={theEvent}
                    />
                </Box>
            ))}
        </Stack>
    )
}

export default EventDetailList;
